// extracted by mini-css-extract-plugin
export default {"root":"tr-clickable_root__Qmq+u","disabled":"tr-clickable_disabled__Z6yJy","placeHolderShimmer":"tr-clickable_placeHolderShimmer__yPZXU"};